import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-hero',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './hero.component.html'
})
export class HeroComponent implements OnInit {
  @Input() title: string | undefined;

  constructor() {}

  ngOnInit(): void {
  }
}
